import React, {useState} from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { Link as RouterLink } from 'react-router-dom';

import stylesLogin from './LoginPigeon.module.css';

import BackgroundImage from '../../assets/login-image.svg';
import Logo from '../../assets/logo_classic.png';
import handshakeImage from '../../assets/waving-hand-svgrepo-com.svg'
import MailOutline from '../../assets/mail_outline.svg';
import KeyOutline from '../../assets/key-outline.svg';


const LoginPigeon = () => {
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        // Po zalogowaniu przekieruj do panelu hodowcy
        navigate('/panel');
    };

return (
    <div className={stylesLogin['login-container']}>
        <div className={stylesLogin['left-column-login']}>
          <div className={stylesLogin['form-container-login']}>
            <div className={stylesLogin['header-form-login']}> 
              <span className={stylesLogin['row-centering-login']}> 
                <span className={stylesLogin['text-white-login']}> Witaj ponowanie </span> 
                <img className={stylesLogin['handshake-login']} src={handshakeImage}></img> 
              </span>
             <span className={stylesLogin['text-grey-login-small-wrap']}> 
                <span className={stylesLogin['new-line']}> 
                  Zaloguj się i zarządzaj dalej swoją hodowlą 
                </span> 
                </span>
             </div>

            <form onSubmit={handleSubmit}>
              <div className={stylesLogin['interspace-login']}></div>

                <label for="email"> <span className={stylesLogin['formfield-title-login']}> E-mail </span> </label>
                <div className={stylesLogin['input-container-login']}>
                  <img src={MailOutline} alt="Ikona2"></img>
                  <input type="email" id="email" placeholder="Wprowadź swój adres email" className={stylesLogin['form-input']}></input>
                </div>

                <div className={stylesLogin['interspace-login']}></div>

                <label for="password"> <span className={stylesLogin['formfield-title-login']}> Hasło </span> </label>
                <div className={stylesLogin['input-container-login']}>
                  <img src={KeyOutline} alt="Ikona3"></img>
                  <input type="password" id="password" placeholder="**********" className={stylesLogin['form-input']}></input>
                </div>

                <div className={stylesLogin['forgot-password-login-container']}>
                  <Link component={RouterLink} to="/forgot-password" underline="none" className={stylesLogin['text-grey-login-small']} >
                    Nie pamiętasz hasła?
                  </Link>
                </div>

              
                <div className={stylesLogin['submit-button-login-container']}>
                  <button type="submit" className={stylesLogin['login-button']}>Zaloguj się</button>
                </div>

                <div className={stylesLogin['title-below-submit-login']}>
                  <span className={stylesLogin['text-grey-login-small']}> Nie masz konta? </span> 
                  <Link component={RouterLink} to="/pigeons-register" underline="none" className={stylesLogin['text-white-login-small']}>
                    Zarejestruj się
                  </Link>
                </div>
                
            </form>
          </div>
        </div>

        <div className={stylesLogin['right-column-login']}>
          <div className={stylesLogin['background-image-container-login']}>
            <img className={stylesLogin['background-image-login']} src={BackgroundImage} alt="Background"></img>
          </div>

          <div className={stylesLogin['logo-image-login-container']}>
            <img className={stylesLogin['logo-image-login']} src={Logo} alt="Logo"></img>
          </div>
        </div>
        
   </div>
  );
}

export default LoginPigeon